<template>
  <div class="row table-sm mr-0 ml-0 p-0">
    <div class="row table-sm mr-0 ml-0 p-0 mb-3 width-100">
      <div
          class="
          col-7
          p-0
          align-self-center
          font-weight-bold
          d-flex
          align-items-center
          w-reset
          mb-sm-2
        "
      >
        <h5 class="d-inline mr-2 font-weight-bold">
          {{ $t("message.promotions") }}
        </h5>
        <crm-refresh @c-click="refresh()"></crm-refresh>
        <div class="text-center d-flex sorddata ml-3">
          <el-input
              size="mini"
              :placeholder="$t('message.search')"
              prefix-icon="el-icon-search"
              clearable
          ></el-input>
        </div>
      </div>
      <div
          class="
          col-5
          align-items-center align-self-center
          text-right
          pr-0
          d-flex
          justify-content-end
          w-reset
        "
      >
        <el-button
          v-can="'promotions.create'"
          size="mini"
          @click="drawer.create.status = true"
        >
          {{ $t("message.create") }}
        </el-button>
        <export-excel
          class="btn excel_btn"
          :data="list"
          @fetch="controlExcelData()"
          worksheet="Промоакции"
          name="Промоакции.xls"
        >
          <el-button size="mini">
            <i class="el-icon-document-delete"></i> Excel
          </el-button>
        </export-excel>
        <crm-column-settings
            :columns="columns"
            :modelName="'paymentTypes'"
            @c-change="updateColumn"
        ></crm-column-settings>
      </div>
    </div>

    <table class="table table-bordered table-hover" v-loading="loadingData">
      <crm-pagination
        :pagination="pagination"
        @c-change="updatePagination"
      />
      <thead>
        <tr>
          <crm-th :column="columns.id" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.name" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.start" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.end" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.services" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.created_at" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.updated_at" :sort="sort" @c-change="updateSort"/>
          <crm-th :column="columns.settings" :sort="sort" @c-change="updateSort"/>
        </tr>
        <tr>
          <th v-if="columns.id.show">
            <el-input
                clearable
                size="mini"
                class="id_input"
                v-model="filterForm.id"
                :placeholder="columns.id.title"
            />
          </th>
          <th v-if="columns.name.show">
            <el-input
                size="mini"
                v-model="filterForm.name"
                :placeholder="columns.name.title"
                clearable
            />
          </th>
          <th v-if="columns.start.show">
            <el-date-picker
              v-model="filterForm.start"
              :placeholder="$t('message.delivery_time')"
              type="date"
              :format="'yyyy-MM-dd'"
              :value-format="'yyyy-MM-dd'"
            />
          </th>
          <th v-if="columns.end.show">
            <el-date-picker
              v-model="filterForm.end"
              :placeholder="$t('message.delivery_time')"
              type="date"
              :format="'yyyy-MM-dd'"
              :value-format="'yyyy-MM-dd'"
            />
          </th>
          <th v-if="columns.services.show">
            <el-select
                v-model="filterForm.service_id"
                filterable
                clearable
                class="w-100"
            >
              <el-option
                style="width: 500px"
                v-for="service in services"
                :key="service.id"
                :value="service.id"
                :label="service.name"
              />
            </el-select>
          </th>
          <th v-if="columns.created_at.show"></th>
          <th v-if="columns.updated_at.show"></th>
          <th v-if="columns.settings.show"></th>
        </tr>
      </thead>

      <transition-group name="flip-list" tag="tbody">
        <tr v-for="promo in list" :key="promo.id" class="cursor-pointer">
          <td v-if="columns.id.show">{{ promo.id }}</td>
          <td v-if="columns.name.show">{{ promo.name }}</td>
          <td v-if="columns.start.show">{{ promo.start }}</td>
          <td v-if="columns.end.show">{{ promo.end }}</td>
          <td v-if="columns.services.show">
            <el-button
              type="success"
              size="mini"
              @click="openModal(promo)"
            >{{
                $t(`message.services`)
              }}</el-button>
          </td>
          <td v-if="columns.created_at.show">{{ promo.created_at }}</td>
          <td v-if="columns.updated_at.show">{{ promo.updated_at }}</td>
          <td v-if="columns.settings.show" class="settings-td">
            <crm-setting-dropdown
                :model="promo"
                name="promotions"
                :actions="actions"
                @edit="edit"
                @delete="destroy"
            />
          </td>
        </tr>
      </transition-group>
    </table>
    <el-dialog
      :title="$t(`message.services`)"
      :visible.sync="dialogVisible"
    >
      <el-table :data="serviceItems">
        <el-table-column label="№" prop="id" align="center"/>
        <el-table-column :label="$t(`message.name`)" prop="name" align="center">
          <template slot-scope="scope">
            {{ scope.row.service.name }}
          </template>
        </el-table-column>
        <el-table-column :label="$t(`message.price`)" prop="price" align="center"/>
        <el-table-column :label="$t(`message.discount_price`)" prop="discount_price" align="center"/>
        <el-table-column :label="$t(`message.secondary_discount_price`)" prop="secondary_discount_price" align="center"/>
      </el-table>
    </el-dialog>
    <el-drawer
        size="60%" :wrapperClosable="false"
        :visible.sync="drawer.create.status"
        :ref="drawer.create.name"
        @opened="drawerOpened(drawer.create.component)"
        @closed="drawerClosed(drawer.create.component)"
    >
      <crm-create
          :ref="drawer.create.component"
          :drawer-name="drawer.create.name"
      ></crm-create>
    </el-drawer>
    <el-drawer
        size="60%" :wrapperClosable="false"
        :visible.sync="drawer.update.status"
        :ref="drawer.update.name"
        @opened="drawerOpened(drawer.update.component)"
        @closed="drawerClosed(drawer.update.component)"
    >
      <crm-update
          :selected="selectedModel"
          :ref="drawer.update.component"
          :drawer-name="drawer.update.name"
      >
      </crm-update>
    </el-drawer>
  </div>
</template>

<script>
import CrmCreate from "./components/crm-create";
import CrmUpdate from "./components/crm-update";
import drawer from "@/utils/mixins/drawer";
import list from "@/utils/mixins/list";
import { mapGetters, mapActions } from "vuex";
export default {
  mixins: [list, drawer],
  name: "scores",
  components: {
    CrmCreate,
    CrmUpdate,
  },
  data() {
    return {
      appModal: false,
      selectedModel: null,
      dialogVisible: false,
      serviceItems: null,
      drawer: {
        create: {
          name: "create",
          status: false,
          component: "componentDrawerCreate",
        },
        update: {
          name: "update",
          status: false,
          component: "componentDrawerUpdate",
        },
      },
      loadingData: false,
    };
  },
  computed: {
    ...mapGetters({
      list: "promotions/list",
      columns: "promotions/columns",
      pagination: "promotions/pagination",
      filter: "promotions/filter",
      sort: "promotions/sort",
      services: "services/inventory"
    }),
    actions: function () {
      return ["edit", "delete"];
    },
  },
  async mounted() {
    this.controlExcelData();
    if (this.services && this.services.length === 0) await this.loadServices();
  },
  methods: {
    ...mapActions({
      updateList: "promotions/index",
      updateSort: "promotions/updateSort",
      updateFilter: "promotions/updateFilter",
      updateColumn: "promotions/updateColumn",
      updatePagination: "promotions/updatePagination",
      editModel: "promotions/show",
      empty: "promotions/empty",
      delete: "promotions/destroy",
      refreshData: "promotions/refreshData",
      loadServices: "services/inventory",
    }),
    refresh() {
      this.refreshData();
    },
    edit(model) {
      this.selectedModel = model;
      this.drawer.update.status = true;
    },
    fetchData() {
      const query = {
        ...this.filter,
        ...this.pagination,
        ...this.sort,
      };
      if (!this.loadingData) {
        this.loadingData = true;
        this.updateList(query)
          .then((res) => {
            this.loadingData = false;
          })
          .catch((err) => {
            this.loadingData = false;
          });
      }
    },
    destroy(model) {
      this.delete(model.id)
        .then((res) => {
          this.$notify({
            title: 'Успешно',
            type: "success",
            offset: 130,
            message: res.message
          });
          this.fetchData();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    openModal(promotion) {
      this.dialogVisible = true;
      this.serviceItems = promotion.promotion_services;
    },
    emptyModel() {
      this.empty();
    },
    controlExcelData() {
      this.excel_fields = {};
      for (let key in this.columns) {
        if (this.columns.hasOwnProperty(key)) {
          let column = this.columns[key];
          if (column.show && column.column !== "settings") {
            switch (column.column) {
              case 'services':
                break;
              default:
                this.excel_fields[column.title] = column.column;
            }
          }
        }
      }
    },
  },
};
</script>

